import { Injectable } from '@angular/core';
import {ResourceService} from '../../../shared/services/resource.service';
import {Offer} from '../../models/offer/offer.model';

@Injectable({
  providedIn: 'root'
})
export class OfferResourceService {

  constructor(private resourceService: ResourceService) { }

  getOfferLogoUri(offer: Offer): string {
    return this.hasOfferLogo(offer) ? this.resourceService.buildResourceURL(offer.insuranceResource.insuranceLogo.logoUri) : null;
  }

  getOfferOWUUri(offer: Offer): string {
    return this.hasOfferOWU(offer) ? this.resourceService.buildResourceURL(offer.insuranceResource.insuranceOwu.owuUri) : null;
  }

  hasOfferLogo(offer: Offer): boolean {
    return !!offer.insuranceResource && !!offer.insuranceResource.insuranceLogo && !!offer.insuranceResource.insuranceLogo.logoUri;
  }

  hasOfferOWU(offer: Offer): boolean {
    return !!offer.insuranceResource && !!offer.insuranceResource.insuranceOwu && !!offer.insuranceResource.insuranceOwu.owuUri;
  }

  updatePdfLinks(): void {
    this.resourceService.updatePdfLinks();
  }
}
